class RichText {
	constructor() {
		document.querySelectorAll(".rich-text .btn-yellow").forEach(item => {
			item.dataset.aos = "btn-yellow";
		});
	}
}
